import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export interface ITrackAmplitudeOpenGalleryParams {
    /** Screen context for the event. Defaults to "km_offer_details" (offer/property detail page). */
    location?: string;
    offerId: number | string;
    propertyId?: number;
    galleryView: "grid" | "viewer" | "map" | "gated";
    photoSection: "gallery" | "construction_photos" | "floor_plan" | "map";
    mediaTabNavigation?: "initial" | "tab_switch";
    photosTotal?: number;
    photoIndex?: number;
    contentAccess?: "full" | "gated";
}

export const trackAmplitudeOpenGallery = (params: ITrackAmplitudeOpenGalleryParams) => {
    const {location = "km_offer_details", offerId, propertyId, galleryView, photoSection, mediaTabNavigation, photosTotal, photoIndex, contentAccess} = params;

    const eventProperties: Record<string, string | number> = {
        location,
        item_id: offerId,
        gallery_view: galleryView,
        photo_section: photoSection
    };

    if (propertyId != null) {
        eventProperties.property_id = propertyId;
    }
    if (mediaTabNavigation != null) {
        eventProperties.media_tab_navigation = mediaTabNavigation;
    }
    if (photosTotal != null) {
        eventProperties.photos_total = photosTotal;
    }
    if (photoIndex != null) {
        eventProperties.photo_index = photoIndex;
    }
    if (contentAccess != null) {
        eventProperties.content_access = contentAccess;
    }

    trackAmplitudeEvent("open_gallery", eventProperties);
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export interface ITrackAmplitudeOpenGalleryParams {
    /** Screen context for the event. Defaults to "km_offer_details" (offer/property detail page). */
    location?: string;
    offerId: number | string;
    propertyId?: number;
    galleryView: "grid" | "viewer" | "map" | "gated";
    photoSection: "gallery" | "construction_photos" | "floor_plan" | "map";
    mediaTabNavigation?: "initial" | "tab_switch";
    photosTotal?: number;
    photoIndex?: number;
    contentAccess?: "full" | "gated";
}

export const trackAmplitudeOpenGallery = (params: ITrackAmplitudeOpenGalleryParams) => {
    const {location = "km_offer_details", offerId, propertyId, galleryView, photoSection, mediaTabNavigation, photosTotal, photoIndex, contentAccess} = params;

    const eventProperties: Record<string, string | number> = {
        location,
        item_id: offerId,
        gallery_view: galleryView,
        photo_section: photoSection
    };

    if (propertyId != null) {
        eventProperties.property_id = propertyId;
    }
    if (mediaTabNavigation != null) {
        eventProperties.media_tab_navigation = mediaTabNavigation;
    }
    if (photosTotal != null) {
        eventProperties.photos_total = photosTotal;
    }
    if (photoIndex != null) {
        eventProperties.photo_index = photoIndex;
    }
    if (contentAccess != null) {
        eventProperties.content_access = contentAccess;
    }

    trackAmplitudeEvent("open_gallery", eventProperties);
};
